import React, { useRef, useState } from 'react';
import { Upload } from 'lucide-react';
import { decodeImportSource, importEncodings, type ImportEncoding } from '../../shared/importEncoding';
import { Field } from './Primitives';

export default function ImportSourceFile({ onDecoded, onError }: {
  onDecoded: (text: string, file: File) => void; onError: (message: string) => void;
}) {
  const [encoding, setEncoding] = useState<ImportEncoding>('auto');
  const [file, setFile] = useState<File>();
  const [detected, setDetected] = useState('');
  const generation = useRef(0);
  const read = async (source: File, selection: ImportEncoding) => {
    setDetected(''); const request = ++generation.current;
    try {
      if (source.size > 5 * 1024 * 1024) throw new Error('Choose a file no larger than 5 MiB.');
      const result = decodeImportSource(new Uint8Array(await source.arrayBuffer()), selection);
      if (request !== generation.current) return;
      setDetected(`${source.name} · ${result.encoding.toUpperCase()} · original file retained`);
      onDecoded(result.text, source);
    } catch (error) { if (request === generation.current) onError((error as Error).message); }
  };
  return <>
    <label className="file-drop"><Upload size={22}/><strong>Choose a file</strong><span>or paste input below (up to 5 MiB)</span><input type="file" aria-label="Import source file" accept=".sql,.ddl,.json,.dataglow,.xml,.xmi,.uml" onChange={async event => {
      const source = event.target.files?.[0]; if (!source) return;
      setFile(source); await read(source, encoding);
    }}/></label>
    <Field label="File encoding"><select aria-label="File encoding" value={encoding} onChange={event => {
      const selection = event.target.value as ImportEncoding; setEncoding(selection); if (file) void read(file, selection);
    }}>{importEncodings.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}</select></Field>
    {detected && <p className="subtle" role="status">{detected}</p>}
  </>;
}
